export default __webpack_public_path__ + "static/video-forestal-16035ac517a70710a757379b49774109.mp4";